import React,{useEffect} from 'react'

import './Sports_team.css'

import { Pic_gallery } from '../../components'


import { gladiatorz_list} from '../../constants/sports'
import { Underline } from '../../widgets'

const gladiatorz="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/Sports/Sportsmeet/Gladiatorz/gladiatorz+(3).webp"

const Gladiatorz = () => {
    useEffect(() => {
        document.title = "ACCET-Gladiatorz";
      }, []);
  return (
    <div className='sport_team_page_cont'>
        <div className='sport_team_header_sec'>
            <div className='sport_team_header_img_holder'>
                <img className='sport_team_header_img' src={gladiatorz} alt="Gladiatorz Logo" />
            </div>
            <div className='sport_team_header_title_holder'>
                <div className='sport_team_header_title maverickz_title'>
                Gladiatorz
                </div>
                <div className='sports_team_header_points'>
                    25 Pts
                </div>
            </div>
        </div>

        <div className='sport_team_gallery_holder'>
            <Underline heading="Winners"/>
            <Pic_gallery img_list={gladiatorz_list.winners}/>
        </div>

        <div className='sport_team_gallery_holder'>
            <Underline heading="Runners"/>
            <Pic_gallery img_list={gladiatorz_list.runners}/>
        </div>

    </div>
  )
}

export default Gladiatorz